
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import api from '../../api';

export default {





components: {
Group,
Cell,
Badge,
XButton,
},
mounted() {
this.getOldData();
},
activated() {
},
data() {
return {
defaultUrl: require('../../assets/images/logo_G7@2x.png'),
avatar: '',
};
},
computed: {
},
methods: {
goToBaseDetail() {
this.$router.push({
name: 'mineBaseDetail',
});
},
getOldData() {
api.vega.user.getUserInfo({}).then((res) => {
const data = res.data.data;
this.avatar = data.avatar;
});
},
logOut() {
this.$store.dispatch('logout', this.$router);
}
},
};
